<template>
    <div>
        <v-card class="mt-3 pb-0 mb-5">
            <v-card-title class="pa-5 pb-3 primary" @click="show = !show" style="cursor: pointer;">
                <p style="color: white;"> Movimientos </p>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="show">
                    <v-card-text style="margin-bottom: 4%;">
                        <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                            :params="displayInputs" :order="[]" @apiDT="apiDT = $event"></DataTable>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
        <div>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modalfirma">
            <v-card>
                <v-toolbar color="primary" dark>Autorizar eliminar movimiento</v-toolbar>
                <v-card-text>
                    <label> Firma electrónica: </label>
                    <br />
                    <v-text-field id="firma" ref="input" v-model="efirma" autocomplete="off" maxlength="17"
                        style="-webkit-text-security: disc;" @focus="Foco()" autofocus solo></v-text-field>
                    <span v-if="msg" id="revfirmaelectronica" style="font-style: italic; color: red">{{ texto }}</span>
                    <br />
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn @click="CerrarModal()">Cerrar</v-btn>
                    <v-btn @click="ValidarFirma()" color="primary" :loading="loading" :disabled="loading">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        </div>
    </div>
   
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import Lideres from "@/services/Lideres/Lideres.service.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import reporteMovimientos from "@/services/Movimientos/Movimientos.service.js";
import Metodosgenerales from "../../../utils/metodosgenerales.vue";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        DataTable
    },
    data() {
        return {
            modalfirma: false,
            efirma: '',
            msg: false,
            loading: false,
            texto: '',
            show: true,
            datoseli:[],
            urlListado: "Lideres/ObtenerMovimientos",
            columns: [
                { name: 'Esid', data: 'Esid', title: "T.P.", formatter: [this, "tpreporte"], orderable: false },
                { name: 'Exfechas', data: 'Exfecha', title: "Fecha" },
                { name: 'Exfechaabo', data: 'Exfechaabo', title: "Fecha Abo" },
                { name: 'Cegrupo', data: 'Cegrupo', title: "Tipo" },
                { name: 'Ceconcepto', data: 'Ceconcepto', title: "Concepto" },
                { name: 'Exresp', data: 'Exresp', title: "Resp" },
                { name: 'Exobs', data: 'Exobs', title: "Observaciones" },
                { name: 'Uslogin', data: 'Uslogin', title: "Usuario" },
                { name: "elimina", data: "elimina", title: "", formatter: [this, "formatearElimnar"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "EliminarMovimiento"] },
            ],
            apiDT: null,
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            },
            permisoLideres: false,
            permisoEliminar: false
        }


    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40,396').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver lideres
                        this.permisoLideres = true;
                    if (permiso.peclave == 396)//Permiso para ver lideres
                        this.permisoEliminar = true;
                });
            }
            if (this.permisoLideres == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        let datos = await MetodosGenerales.obtenerSessionReporte('valider');
        this.displayInputs = {
            nrreporte: datos.nrreporte,
            svindice: datos.svindice,
            aiclave: datos.aiclave,
        };
       
    },
    methods: {
        tpreporte(datos) {
            return datos.Esid == 7 ? `<i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-open-variant theme--light success--text"></i>` : `<i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-open theme--light error--text"></i>`;
        },
        formatearElimnar(datos) {
            return (datos.elimina && this.permisoEliminar) ? `<div><button type="button" class="eliminar v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default error dt-formatterAction" data-action="0" data-params="${datos.exid}" title="Eliminar"><span class="v-btn__content"><i data-v-6d45dbae="" aria-hidden="true" class="v-icon notranslate mdi mdi-trash-can-outline theme--light"></i></span></button></div>` : '';
        },
        EliminarMovimiento(params, datos, fila) {
            this.efirma = '';
            this.modalfirma=true;
            this.datoseli=datos;
        },
        Foco() {
            this.msg = false;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        }, CerrarModal() {
            this.modalfirma = false;
            this.firma = '';
            this.texto = '';
        },
        async ValidarFirma() {
            if (this.efirma.length == 0) {
                this.msg = true;
                this.texto = 'Campo de rquerido';
            }
            else if (this.efirma.length < 8 || this.efirma.length > 16) {
                this.msg = true;
                this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
            }
            else {
                this.loading = true;
                let eFirmaValidResponse = await Metodosgenerales.ValidarEFirma(this.efirma,
                this.displayInputs.nrreporte,this.displayInputs.svindice, 'TBEXPEDIENTE', MetodosGenerales.ObtenerUserName(),'Elimina movimientos Lider',
                this.datoseli.ceclave);
                if (eFirmaValidResponse == 1) {
                   
                        await this.eliminacionMov();
                  
                } else {
                    this.msg = true;
                    this.texto = 'Su firma electrónica es incorrecta';
                }
                this.efirma = '';
                this.loading = false;
            }
        },
        async eliminacionMov(){
          
            this.showcargando = true;
                    let data = new FormData();
                    data.append("nrreporte", this.displayInputs.nrreporte);
                    data.append("svindice", this.displayInputs.svindice);
                    data.append("ceclave", this.datoseli.ceclave);
                    data.append("exid", this.datoseli.exid);
                    let response = await Lideres.EliminarMovimiento(data);
                    this.CerrarModal();
                    if (response.respuesta == 1) {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            text: "El movimiento se elimino correctamente",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonColor: "#3085d6",
                            confirmButtonText: "Aceptar",
                        }).then(async () => {
                            this.reloadTable();
                        });
                    } else {
                        this.showcargando = false;
                        this.$swal({
                            position: "center",
                            icon: "error",
                            text: "Ocurrio un error, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: true,
                            timer: 2000,
                        });
                    }
        }
    }
}
</script>

<style></style>